import React, { useEffect } from 'react';
import { Nav } from './components/Nav';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { VirtualTours } from './pages/VirtualTours';
import { useHashRoute } from './hooks/useHashRoute';
export function App() {
  const route = useHashRoute();
  useEffect(() => {
    document.title = route === 'tours' ? 'Virtual Tours | MUNISVerse' : 'MUNISVerse | Immersive Virtual Property Tours Nigeria';
  }, [route]);
  return <div className="min-h-screen bg-zinc-950 text-zinc-50 selection:bg-white/20" data-id="element-0" data-mp="2mmce69087cca">
      <Nav data-id="element-1" data-mp="31aqfuglwour9" />
      {route === 'tours' ? <VirtualTours data-id="element-2" data-mp="31ayvgg9eye65" /> : <Home data-id="element-3" data-mp="31bi7xhgaoacs" />}
      <Footer data-id="element-4" data-mp="31c1j8fbfw0hu" />
    </div>;
}